import { AviaPassengerType, CheckoutOrderFragment, PassengerFragment, TravellerFieldEnum } from '@websky/graphql';
import { concatPassengerNames, getTravellerName } from '../../../utils';

type TravellerInfo = {
	name: string;
	phone: string;
	email: string;
};

export const getTravellerInfo = (
	customer: CheckoutOrderFragment['customer'],
	travellers: PassengerFragment[],
	travellerIds: string[]
): TravellerInfo => {
	const customerValues = new Map(customer.values.map(v => [v.type, v.value]));
	const customerPhone = customerValues.get(TravellerFieldEnum.Phone);
	const customerEmail = customerValues.get(TravellerFieldEnum.Email);

	if (customerPhone?.length || customerEmail?.length) {
		const travellerInfo: TravellerInfo = {
			name: '',
			phone: customerPhone,
			email: customerEmail
		};

		const firstTraveller = getFilteredTravellers(travellers, travellerIds)[0];
		if (firstTraveller) {
			travellerInfo.name = getTravellerName(firstTraveller);
		}

		return travellerInfo;
	}

	return getValidTravellerInfo(travellers, travellerIds);
};

function getFilteredTravellers(travellers: PassengerFragment[], travellerIds: string[]) {
	return travellers.filter(t => travellerIds.includes(t.id) && t.type === AviaPassengerType.ADT);
}

/** return first traveller, which contain phone or email*/
function getValidTravellerInfo(travellers: PassengerFragment[], travellerIds: string[]): TravellerInfo {
	const returnValue: TravellerInfo = {
		name: '',
		phone: '',
		email: ''
	};

	const filledFields = [
		TravellerFieldEnum.FirstName,
		TravellerFieldEnum.LastName,
		TravellerFieldEnum.Phone,
		TravellerFieldEnum.Email
	];
	const targetFields = [TravellerFieldEnum.Phone, TravellerFieldEnum.Email];

	const travellerFields: Map<TravellerFieldEnum, string> = new Map();

	let travellerIsValid = false;
	for (const traveller of getFilteredTravellers(travellers, travellerIds)) {
		travellerFields.clear();

		for (const value of traveller.values) {
			if (filledFields.includes(value.type)) {
				travellerFields.set(value.type, value.value);

				if (targetFields.includes(value.type) && value.value?.length) {
					travellerIsValid = true;
				}

				if (travellerFields.size === filledFields.length) {
					break;
				}
			}
		}

		if (travellerIsValid) {
			returnValue.name = concatPassengerNames({
				lastName: travellerFields.get(TravellerFieldEnum.LastName),
				firstName: travellerFields.get(TravellerFieldEnum.FirstName)
			});
			returnValue.phone = travellerFields.get(TravellerFieldEnum.Phone);
			returnValue.email = travellerFields.get(TravellerFieldEnum.Email);

			break;
		}
	}

	return returnValue;
}
